import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {redeemPromoCode} from 'growth/PromoCodeDAO';
import notifications from 'notifications';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {Header1} from 'ui-library/Headers';
import {LABEL_STYLES, Size} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';
import {BasicEvent, InputChangeEvent} from 'util/Types';

interface Props {
  initialCode?: string;
}

interface State {
  code: string;
  isSubmitting: boolean;
}

class PromoCodesView extends React.Component<Props, State> {
  override state: State = {
    code: this.props.initialCode || '',
    isSubmitting: false,
  };

  _isSubmitDisabled = (): boolean => !this.state.code || this.state.isSubmitting;

  _handleChangePromoCode = (e: InputChangeEvent): void => {
    this.setState({code: e.target.value});
  };

  _handleSubmit = async (e: BasicEvent): Promise<void> => {
    e.preventDefault();
    if (this._isSubmitDisabled()) {
      return;
    }
    this.setState({
      isSubmitting: true,
    });
    try {
      await redeemPromoCode(this.state.code);
      notifications.success("Promo code successfully applied! You've been awarded 10GB of extra space.");
      this.setState({code: ''});
    } finally {
      this.setState({isSubmitting: false});
    }
  };

  override render(): JSX.Element {
    return (
      <div>
        <Header1 className={css(styles.headerText)}>Promo Codes</Header1>
        <Row>
          <Col className="col-xs-6">
            <form onSubmit={this._handleSubmit} className={css(styles.form)}>
              <TextField
                className="u-flex-grow u-small-spacing-right"
                label="Promo Code"
                size={Size.MEDIUM}
                labelStyle={LABEL_STYLES.HIDDEN}
                placeholder="Promo code"
                value={this.state.code}
                onChange={this._handleChangePromoCode}
              />
              <Button
                buttonStyle={ButtonStyle.SECONDARY}
                disabled={this._isSubmitDisabled()}
                size={ButtonSize.MEDIUM}
                text="Submit"
                type="submit"
                onClick={(e: BasicEvent) => {
                  if (this._isSubmitDisabled()) {
                    e.preventDefault();
                  }
                }}
              />
            </form>
          </Col>
        </Row>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  headerText: {
    fontSize: 24,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    marginTop: 15,
    marginBottom: 15,
  },
  form: {
    display: 'flex',
  },
});

export default PromoCodesView;
